import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["errorMessage"];

  validate(event) {
    if (!this.element.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();

      this.element.classList.add("was-validated");

      this.errorMessageTarget.classList.remove("d-none");

      const firstInvalid = this.element.querySelector(":invalid");
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    } else {
      this.errorMessageTarget.classList.add("d-none");
    }
  }
}
